<template>
  <div style="z-index:600000">
      <ui-modal-old name="create-company-modal">
        <template v-slot:icon>
          <i class="fas fa-building"></i>
        </template>
        <template v-slot:title>Create A Company</template>

        <template v-slot:main>
          <crud-errors :errors="errors"></crud-errors>

          <dl>
            <dt>Name</dt>
            <dd><input type="text" v-model="new_item.name"/></dd>
            <dt>Email</dt>
            <dd><input type="email" v-model="new_item.email"/></dd>
            <dt>Website</dt>
            <dd><input type="text" v-model="new_item.website"/></dd>
          </dl>

        </template>
        <template v-slot:buttons>
          <ui-button class="sm:ml-2" colour="green" @click.prevent="addItem()">
            <i class="fas fa-plus-circle mr-1"></i> Create Company
          </ui-button>
        </template>
      </ui-modal-old>
  </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                name:'companies',
                new_item:{},
                errors: null
            }
        },
        methods: {
            openModal(){
              this.new_item = {};
              this.resetErrors();
              window.eventBus.$emit('modal-open-create-company-modal');
            },
            closeModal(){
              window.eventBus.$emit('modal-close-create-company-modal');
              this.new_item = {};
              this.resetErrors();
            },
            resetErrors(){
                window.eventBus.$emit('crud-errors-dismissed');
            },
            addItem() {
                var that = this;
                var data = $.extend({}, this.new_item);

                axios.post(appUrls.companies.store, data)
                    .then(response => {
                        window.eventBus.$emit('company-created',response.data.data);

                        that.closeModal();
                    }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },
            backToNav: function(){
                window.eventBus.$emit('crud-back-to-nav-'+this.name);
            }
        },
        mounted() {
            var that = this;

            window.eventBus.$on('create-new-company', function () {
              that.openModal();
            });

            window.eventBus.$on('crud-errors-dismissed', function () {
                that.errors = null;
            });
        }
    }
</script>

<style lang="scss" scoped>

</style>
